import { gql, TypedDocumentNode } from "@apollo/client";

import { QueryMetricsRangeArgs, SpaceliftMetrics } from "types/generated";

type GetLeadTimeForChangesAverageData = {
  metricsRange: Pick<SpaceliftMetrics, "averageLeadTimeForChangesValue">;
};

export const GET_LEAD_TIME_FOR_CHANGES_AVERAGE: TypedDocumentNode<
  GetLeadTimeForChangesAverageData,
  QueryMetricsRangeArgs
> = gql`
  query GetLeadTimeForChangesAverage($input: MetricsInput) {
    metricsRange(input: $input) {
      averageLeadTimeForChangesValue {
        value
      }
    }
  }
`;
